// Embedded B2 German vocabulary seed (≈3000 entries) bundled with the app.
// Each entry has a heuristically detected word-type — the AI service refines
// the type and fills in the rest of the dictionary entry on first study.

const RAW = `abatt
abbilden
Abbildung
abbrechen
abdecken
abdrehen
Abend
Abendessen
Abendrot
abends
Abenteuer
aber
Abfall
Abflug
Abgabe
Abgas
Abgase
abgeben
Abgrenzung
abhalten
abhängig
Abhängigkeit
abheften
abholen
Abiturvorbereitung
Ablauf
ablaufen
Ablaufplan
ablehnen
ablehnend
Ablehnung
ableiten
Ableitung
ablenken
Ablenkung
abmachen
Abmachung
abmildern
Abnahme
abnehmen
Abonnement
abonnieren
abrechnen
Abrechnung
Absage
absagen
abschaffen
abschätzen
Abschätzung
abschicken
Abschied
abschließen
abschließend
Abschluss
Abschlusserklärung
Abschnitt
abschwächen
Absen
absichern
Absicherung
Absicht
absichtlich
absolut
absolvieren
absprechen
Abstand
Abstellplatz
abstimmen
Abstimmung
abstrakt
Abteilung
Abteilungsleiter/in
abwägen
Abwägung
Abwanderung
abwarten
Abwasser
Abwechslung
abwechslungsreich
Abweichung
achten
Achtung
Adresse
AGB
akademisch
Akademisierung
Akquisition
aktiv
aktualisieren
Aktualisierung
aktuell
akzeptabel
Akzeptanz
akzeptieren
Albtraum
Alkohol
alle
allein
allerdings
Allergie
allergisch
allgegenwärtig
allgemein
Alliierte
Alltag
alltäglich
als
also
alt
Altenpfleger/in
Alter
alternativ
Alternative
alternativlos
Altöl
Altpapier
Aluminium
Ambition
ambitioniert
amtlich
Amtssprache
amüsieren
an
Analyse
Analysemethode
analysieren
Anbau
anbieten
Anbieter
andauernd
ändern
anders
Änderung
anerkannt
anerkennen
Anerkennung
anfahren
Anfang
anfangen
anfangs
anfassen
anfertigen
Anfertigung
anfordern
Anforderung
Anfrage
Angabe
angeben
Angebot
Angehörige
Angelegenheit
angemessen
angenehm
Angestellte
angewöhnen
angreifen
Angst
ängstlich
anhaltend
anheben
anklagen
ankommen
Ankunft
ankündigen
Ankündigung
Anlage
Anlass
anlässlich
Anleitung
anmachen
anmelden
Anmeldung
Annäherung
Annahme
annehmen
anonym
anpassen
Anpassung
Anpassungsfähigkeit
Anprobe
anprobieren
anrechnen
anregen
Anregung
Anruf
anrufen
Ansage
Anschaffung
anschauen
anschließen
anschließend
Anschluss
anschnallen
Anschrift
ansehen
Ansicht
ansonsten
ansprechen
Ansprechperson
Anspruch
anspruchsvoll
anspruchsvolles
Anstalt
anstatt
anstecken
ansteckend
ansteigen
Anstellung
Anstieg
anstiften
Anstoß
anstreben
anstreichen
anstrengen
anstrengend
Anstrengung
Anteil
Antrag
Antwort
antworten
anvertrauen
Anwalt
anweisen
Anweisung
Anwendbarkeit
anwenden
Anwendung
anwerben
anwesend
Anzahl
Anzeige
anzeigen
Anzeigetafel
anziehen
Anzug
Apfel
Apotheke
Apparat
Appetit
Arbeit
arbeiten
Arbeitgeber
Arbeitnehmer
Arbeitsbedingungen
Arbeitskraft
Arbeitslosigkeit
arbeitsmarktfähig
arbeitsmarktrelevant
Arbeitsmigration
Arbeitsplatz
Arbeitsstelle
Arbeitsweise
Arbeitszeit
Arbeitszimmer
Arbeitszufriedenheit
Ärger
ärgerlich
ärgern
Argument
Argumentationskette
argumentieren
arm
Armut
arrogant
Art
Artikel
Artikelnummer
Arzt
Ärztin
ärztlich
Asche
Aspekt
Assistenz
assistieren
Astronaut/in
Asyl
atmen
Atmung
atmungsaktiv
attraktiv
Attraktivität
auch
auf
Aufbau
aufbauen
aufdrehen
Aufenthalt
auffallen
Auffassung
auffordern
Aufforderung
aufführen
Aufführung
Aufgabe
aufgeben
aufgrund
aufhalten
aufheben
Aufhebung
aufhören
aufklären
Aufklärung
Aufkleber
aufkommen
Auflage
auflösen
Auflösung
aufmachen
aufmerksam
Aufmerksamkeit
Aufnahme
aufnehmen
aufpassen
aufräumen
aufrechterhalten
Aufrechterhaltung
aufregen
aufregend
Aufregung
aufrichtig
Aufruf
aufschlussreich
aufschreiben
aufstehen
aufteilen
Aufteilung
Auftrag
Auftragsnummer
auftreten
aufwachen
aufwachsen
aufweisen
aufwenden
Aufzug
Auge
Augenblick
aus
Ausbau
ausbauen
ausbilden
Ausbildung
ausbrechen
ausbreiten
Ausbreitung
Ausdauer
ausdehnen
Ausdruck
Ausdrucksfähigkeit
ausdrücken
auseinandersetzen
Auseinandersetzung
Ausfall
ausfallen
Ausflug
ausführen
ausführlich
Ausführung
ausfüllen
Ausgabe
Ausgang
ausgeben
ausgehen
ausgewogen
Ausgewogenheit
ausgezeichnet
ausgleichen
auskommen
Auskunft
auslasten
Auslastung
ausleihen
ausliefern
auslösen
Auslösung
ausmachen
Ausnahme
ausnutzen
Ausnutzung
ausparken
ausprobieren
ausreichen
ausreichend
ausrichten
Ausrichtung
ausruhen
Ausrüstung
Aussage
aussagekräftig
aussagekräftige
aussagen
ausschalten
ausschlafen
ausschließen
aussehen
außenspiegel
außer
außerdem
außergewöhnlich
aussetzen
Aussetzung
Aussicht
Aussprache
aussprechen
Ausstattung
aussteigen
ausstellen
Ausstellung
Ausstoß
ausstoßen
aussuchen
Austausch
austauschen
ausüben
Auswahl
auswählen
Auswanderer
auswandern
Auswanderung
Ausweg
ausweichen
Ausweis
ausweiten
Ausweitung
auswendig
auswerten
Auswertung
auswirken
Auswirkung
auszeichnen
Auszeichnung
ausziehen
Auszug
Auto
Autofahrer/in
Automarke
Automat
automatisch
automatisieren
Automatisierung
Autorennen
Autorität
Autoteil
Autoversicherung
Baby
Bachelor
backen
Bäckerei
Bad
baden
Bahn
Bahnhof
Bahnsteig
Balance
bald
Balkon
Balkongeländer
Ball
Banane
Bank
Bankeinzug
Barcode
Bargeld
barmherzig
Barriere
Bau
Bauch
bauen
Bauer
Baum
Baustelle
beabsichtigen
beachten
Beachtung
Beamte
beantragen
beantworten
bearbeiten
Bearbeitung
beauftragen
Beauftragte
Becher
bedanken
bedanklich
Bedarf
bedarfsgerecht
bedauerlich
bedauern
bedeuten
bedeutend
Bedeutung
bedeutungslos
bedienen
Bedienung
bedingen
bedingt
Bedingung
bedrohen
Bedrohung
bedürfen
beeinflussen
beeinflusst
beeinträchtigen
Beeinträchtigung
beenden
Beerdigung
befähigen
Befähigung
Befehl
befehlen
befestigen
befinden
Beförderung
befragen
befreien
Befreiung
befristet
Befristung
befürchten
begegnen
begeistern
begeistert
Begeisterung
Beginn
beginnen
beglaubigen
Beglaubigung
begleiten
Begleitperson
Begleitung
beglückwünschen
Begriff
begründen
Begründung
begrüßen
behalten
Behälter
behandeln
Behandlung
behaupten
Behauptung
beherrschen
behindern
Behörde
bei
beide
beilegen
Bein
Beispiel
beispiellos
Beitrag
beitragen
beitreten
Beitritt
bekämpfen
bekannt
Bekannte
bekanntlich
Bekanntschaft
beklagen
Bekleidung
bekommen
belastbar
Belastbarkeit
belasten
Belastung
Belastungsgrenze
Beleg
belegen
Belegschaft
beleidigen
Beleidigung
beleuchten
beliebt
bemängeln
bemerken
bemerkenswert
Bemerkung
bemessen
bemühen
benachrichtigen
Benachrichtigung
benachteiligen
Benachteiligung
benötigen
benutzen
Benutzer
Benutzung
Benzin
beobachten
Beobachtung
bequem
beraten
Beratung
berechnen
Berechnung
berechtigen
berechtigt
Berechtigung
Bereich
bereit
bereiten
bereits
Bereitschaft
bereitstellen
Bereitstellung
bereitwillig
bereuen
Berghütte
Bergpfad
Bericht
berichten
Berichterstattung
Beruf
berufen
Berufsbildung
Berufserfahrung
Berufsleben
Berufstätigkeit
Berufung
beruhigen
Beruhigung
berücksichtigen
Berücksichtigung
berühmt
berühren
Berührung
Besatzungszone
beschädigen
Beschädigung
beschäftigen
beschäftigt
Beschäftigung
bescheid
bescheiden
bescheinigen
Bescheinigung
beschimpfen
Beschimpfung
beschleunigen
Beschleunigung
beschließen
Beschluss
beschränken
Beschränkung
beschreiben
Beschreibung
Beschwerde
beschweren
beseitigen
Beseitigung
Besetzung
besichtigen
Besichtigung
besiegen
besitzen
Besitzer
besonders
besorgen
besorgt
besprechen
Besprechung
Besprechungszimmer
besser
Besserung
Bestandteil
bestärken
bestätigen
Bestätigung
Bestehen
bestellen
Bestellhotline
Bestellung
bestimmen
bestimmt
Bestimmung
bestrafen
Bestrafung
bestreiten
Besuch
besuchen
Besucher
beteiligen
Beteiligung
betonen
Betonung
betrachten
Betrachtung
Betrachtungsweise
Betrag
betragen
betreffen
betreffend
betreten
betreuen
Betreuer
Betrieb
betriebsintern
Betriebswirtschaft
Betrug
betrunken
betrügen
Bett
beurteilen
Beurteilung
bevorzugen
bevölkern
Bevölkerung
Bevölkerungsentwicklung
bewahrheiten
bewältigen
Bewältigung
bewegen
Bewegung
Beweis
beweisen
bewerben
Bewerbung
Bewerbungsschreiben
bewerten
Bewertung
bewilligen
Bewilligung
bewirken
bewohnen
Bewohner/in
bewusst
Bewusstsein
Bewusstseinsbildung
bezahlen
Bezahlvorgang
bezeichnen
Bezeichnung
beziehen
Beziehung
beziehungsweise
bezüglich
Bibliothek
biegen
Bier
Biergarten
bieten
Bilanz
Bilanzbuchhalter/in
bilanzieren
Bild
bilden
Bildung
Bildungsbeteiligung
Bildungsmaßnahme
Bildungsreform
billig
Bindung
Bio
Biologie
biologisch
Bioprodukt
Birne
bis
bisher
bislang
Bitte
bitten
bitter
blasen
blass
Blatt
blau
bleiben
Bleistift
Blick
blicken
blind
Blinker
Blitz
Blockade
blond
bloß
Blume
Blumentopf
Bluse
Blut
bluten
blühen
Blütenblatt
Boden
Bohne
bohren
Bombe
Boot
Botschaft
Boxen
böse
Branche
braten
brauchen
braun
brav
brechen
breit
Breite
bremsen
brennen
Brief
Briefpapier
Brille
bringen
Broschüre
Brot
Bruder
brutto
Brücke
Buch
buchen
Budget
budgetieren
Budgetierung
Bundeskanzler/in
Bundesrepublik
bunt
Bus
Bücherwurm
bürgen
Bürger
Bürger/in
Bürgerinitiative
Bürgerkrieg
Büro
Büroalltag
Büroassistent/in
bürokratisch
Büromaterial
Büroraum
Bürozeit
bürsten
Callcenter
campen
Camper/in
Campingplatz
Catering
catern
Chance
Chancengerechtigkeit
Chancengleichheit
Chancennutzung
Charakter
charakterisieren
Charakterisierung
charakteristisch
Check
Chef
Chefin
Chemie
Chemikalie
chemisch
Chips
chronisch
clever
Computer
Container
da
Dach
daher
dahin
dämmen
danach
daneben
dankbar
danken
dann
darlegen
darstellbar
darstellen
darum
darüber
dass
Datenauswertung
datenbasiert
Datenerhebung
Datenschutz
Datensicherheit
Datum
dauerhaft
dauernd
Debatte
debattieren
Deckel
deckeln
decken
definieren
degradieren
dehnen
dementsprechend
demnach
demnächst
demografisch
Demokratie
demokratisch
Demonstration
demonstrieren
denken
Denkweise
denn
dennoch
deshalb
dessen
deswegen
detailliert
Detektivgeschichte
deutlich
DeutscheDemokratischeRepublik
Deutung
Diabetiker/in
Diagnose
Diagramm
Dialog
Diät
dicht
Diebstahl
Dienstleistung
Dienstreise
diesbezüglich
Differenz
differenzieren
differenziert
Differenzierung
digital
digitalisieren
Digitalisierung
Ding
direkt
Diskussion
diskutieren
Distanz
diszipliniert
divers
Diversität
Dokumentation
dokumentieren
Dominanz
dominieren
doof
Doppelbett
doppelt
Doppelzimmer
Dorf
dort
Döner
dramatisch
dransein
drastisch
dreckig
dringend
drinnen
dumm
dunkel
durch
durchführen
Durchführung
durchlässig
Durchschnitt
durchschnittlich
durstig
dünn
dürfen
DVD
dynamisch
Ebene
ebenfalls
ebenso
Echo
echt
Ecke
edel
effektiv
effizient
Effizienz
Effizienzsteigerung
egoistisch
Ehe
ehemalig
eher
Ehre
Ehrgeiz
ehrlich
Eierkarton
Eierschale
Eifersucht
eifersüchtig
eigen
Eigeninitiative
Eigenmotivation
Eigenschaft
eigenständig
Eigenständigkeit
eigentlich
Eigentum
eigenverantwortlich
Eigenverantwortung
eignen
Eignung
Eile
eilen
eilig
einbauen
einbeziehen
einbrechen
Einbrecher/in
Einbruch
einchecken
eindeuten
eindeutig
eindringen
Eindruck
eindrucksvoll
eineindeutig
einerseits
einfach
einfallen
einfließen
Einfluss
Einflussnahme
einflussreich
einfrieren
einfügen
einführen
Einführung
eingeben
eingehen
eingreifen
Eingriff
einhalten
einigen
Einigung
Einkauf
einkaufen
Einkommen
Einkunft
einladen
Einladung
einlegen
einleiten
Einleitung
einlösen
einmal
Einnahme
einordnen
Einordnung
einparken
einreichen
einrichten
Einrichtung
einsam
Einsamkeit
Einsatz
einschalten
einschätzen
Einschätzung
einschlafen
einschließlich
Einschnitt
einschränken
Einschränkung
einschreiben
einsehen
einseitig
Einseitigkeit
einsetzen
Einsicht
einsparen
Einsparung
einsperren
einsteigen
Einsteigezeit
einstellen
Einstellung
Einstieg
eintragen
eintreffen
eintreten
Eintritt
Eintrittsdatum
einverstanden
Einwände
einwandern
Einwanderung
einwerben
einwilligen
einwirken
Einwohnerzahl
Einzahlung
Einzelheit
einzeln
Einzelteil
Einzelzimmer
einziehen
einzigartig
Eis
Eisenbahn
Eishockey
Eiskunstlauf
Eiweiß
ekeln
elastisch
elegant
elektrisch
Elektroauto
elektronisch
eliminieren
Eliminierung
Eltern
Emotion
emotional
Empfang
empfangen
empfehlen
Empfehlung
empfinden
empfindlich
Empfindung
Empirie
empirisch
empirische
Ende
enden
endlich
energieeffizient
Energiekosten
Energiequelle
Energiesparhaus
Energiesparlampe
Energieverschwendung
Energiewende
energisch
eng
Engagement
engagieren
Enkel
enorm
entbehren
entdecken
Entdeckung
entfernen
Entfernung
entführen
Entführung
entgegenkommen
enthalten
Enthaltung
entkommen
entlang
entlassen
Entlassung
entlasten
Entlastung
Entlohnung
entmutigen
entnehmen
entscheiden
entscheidend
Entscheidung
Entscheidungsfindung
Entscheidungsfreiheit
entschuldigen
Entschuldigung
entsetzen
entsorgen
Entsorgung
entspannen
entspannend
entsprechen
entsprechend
entstehen
Entstehung
enttäuschen
enttäuscht
Enttäuschung
entwerfen
entwickeln
Entwicklung
Entwicklungsperspektive
Entwurf
erachten
erarbeiten
Erbe
erben
erbeuten
Erbin
erblicken
erbrechen
Erdbeben
Erde
Erderwärmung
Ereignis
erfahren
Erfahrung
erfassen
Erfassung
erfinden
Erfindung
Erfolg
erfolgreich
erfolgsorientiert
Erfolgswahrscheinlichkeit
erforderlich
erfordern
Erfordernis
erfreuen
erfreulich
erfüllen
Erfüllung
ergänzen
Ergänzung
ergeben
Ergebnis
ergreifen
Erhalt
erhalten
erhältlich
erheblich
Erhebung
erholen
Erholung
erhöhen
Erhöhung
erinnern
Erinnerung
Erkältung
erkennen
Erkenntnis
Erkenntnisgewinnung
erklären
Erklärung
erkunden
erkundigen
Erkundung
erlangen
erlauben
Erlaubnis
erläutern
Erläuterung
erleben
Erlebnis
erledigen
erleichtern
Erleichterung
erleiden
Erlös
erlöschen
ermitteln
Ermittlung
ermöglichen
Ermöglichung
ernähren
Ernährung
ernennen
Ernennung
erneuern
Erneuerung
ernst
ernsthaft
eröffnen
Eröffnung
Erreichbarkeit
erreichen
errichten
Errichtung
Ersatz
erscheinen
erschöpft
Erschöpfung
erschrecken
erschweren
Erschwernis
ersetzen
ersparen
Ersparnisse
erst
erstatten
Erstattung
erstaunen
erstaunt
Erstellung
erstklassig
ertragen
erwägen
Erwägung
erwähnen
erwarten
Erwartung
Erwartungshaltung
erweisen
erweitern
Erweiterung
Erwerb
erwerben
Erwerbsquote
Erwerbstätigkeit
erwidern
erwischen
erwünscht
erzählen
Erzähler
Erzählung
erzeugen
Erzeugnis
erziehen
Erziehung
Esel
eskalieren
essen
Esser/in
Essig
etablieren
Etage
Ethik
Etikett
etwas
Euro
Euroeinführung
EuropäischeUnion
Evaluation
evaluieren
eventuell
evidenzbasiert
ewig
exakt
Existenz
exotisch
Experiment
Experte
Experte/Expertin
expertenhaft
Export
extern
extrem
exzellent
Exzellenz
Fabel
Fabrik
Fach
Fachbereich
Fachkenntnis
Fachkompetenz
Fachkraft
Fachkräftemangel
fachlich
fachübergreifend
Fackel
fähig
Fähigkeit
fahren
Fahrer
Fahrerseite
Fahrplan
Fahrt
fair
Fairness
Faktenlage
faktenorientiert
faktisch
Faktor
Fall
fallen
fällen
falls
falsch
familiär
Familie
Fan
fangen
Fantasie
fantastisch
Farbe
Farbklecks
fassen
fasten
Faszination
faszinieren
faul
Fax
Fazit
Fe
fehlen
fehlend
Fehlentscheidung
Fehlentwicklung
Fehler
fehlerhaft
Fehlinterpretation
Feier
Feierabend
feiern
Feiertag
feige
fein
Feind
Feld
Felge
Fenster
Ferien
fern
Fernbedienung
Fernrohr
Fernsehen
fertig
Fertiggericht
Fessel
Fest
Festanstellung
festkleben
festlegen
Festlegung
Festnahme
festnehmen
Festplatte
feststellen
Feststellung
fett
feucht
Feuchtigkeit
Feuer
Feuerwehr
Fieber
Figur
Film
Filter
finanziell
finanzieren
Finanzierung
Finanzwesen
finden
Finger
Firma
Firmensitz
Fisch
fit
Fitness
flach
Fläche
Flamme
Flasche
Fleck
Fleisch
fleischfrei
fleischlos
Fleiß
fleißig
flexibel
Flexibilität
fliegen
fliehen
fließen
fließend
Fluch
fluchen
Flucht
Flug
Flugbegleiter/in
Fluggast
Fluggesellschaft
Flughafen
Flugzeug
Fluss
flüchtig
Flüchtling
flüssig
Flüssigkeit
Folge
folgen
folgendermaßen
folglich
fordern
Forderung
Form
formal
Formalität
formell
Formular
formulieren
Formulierung
forschen
Forschung
Forschungsarbeit
Fortbildung
Fortschritt
fortschrittlich
fortsetzen
Fortsetzung
Foto
fotografieren
Fotokopie
Föhn
fördern
Förderung
förmlich
Förster/in
Frage
fragen
Fragestellung
fraglich
fragwürdig
Fragwürdigkeit
Frau
frei
Freiheit
freisetzen
Freisetzung
freisprechen
freiwillig
Freiwillige
Freizeit
fremd
Fremde
Fremdsprache
fressen
Freude
freuen
Freund
Freundeskreis
Freundin
freundlich
Freundlichkeit
Freundschaft
Frieden
friedlich
frieren
frisch
Frist
fristgerecht
fristlos
Frisur
froh
Frosch
fröhlich
Frucht
Frust
Frustration
frustrieren
frustriert
früh
Frühling
Frühlingsduft
Frühstück
frühstücken
Fuchs
fundamental
Fundbüro
Funktion
funktionieren
Furcht
furchtbar
Fuß
Fußball
Fußballclub
fühlen
führen
Führerschein
Führung
Führungsebene
Führungskompetenz
Führungskraft
Führungszeugnis
füllen
fürchten
füttern
Gabel
Galerie
Gang
ganz
ganzheitlich
Garage
Garantie
garantieren
garantiert
Garderobe
Garnele
Garten
Gas
Gast
Gastarbeiter/in
Gastronomie
Gate
Gebäck
Gebäude
geben
Geber
Gebiet
gebildet
gebrauchen
Gebrauchtwagen
Geburt
Geburtstag
Gebühr
Gedächtnis
Gedanke
gedeihen
Gedicht
Geduld
geduldig
geeignet
Gefahr
gefährlich
gefallen
Gefängnis
Gefühl
Gegebenheit
gegen
Gegend
Gegensatz
gegensätzlich
Gegenstand
Gegenteil
gegenüberstellen
Gegenvorschlag
Gegenwart
Gegner/in
Gehalt
Gehaltsvorstellung
geheim
Geheimnis
gehen
Gehirn
gehorchen
gehören
Geige
Geist
Geiz
geizig
gelassen
Geld
Gelegenheit
gelegentlich
Gelenk
gelingen
gelten
geltend
Geltung
gemeinsam
Gemeinsamkeit
Gemeinschaft
Gemeinschaftsraum
Gemüse
Gemüsehändler/in
gemütlich
genau
genehmigen
Genehmigung
Generation
generationenübergreifend
generell
generieren
genesen
genetisch
Genie
genießen
genug
Genuss
genügen
genügend
Gepäck
Gepäckausgabe
Gepäckband
Gerät
geraten
Geräusch
gerecht
Gerechtigkeit
Gericht
gering
gern
Geruch
gesamt
Gesamtheit
Geschäft
geschäftlich
Geschäftsführer/in
Geschäftsführung
Geschäftsjahr
geschehen
Geschenk
Geschichte
geschickt
Geschirr
Geschlecht
geschlossen
Geschmack
geschmacklos
Geschwindigkeit
Geschwister
Gesellschaft
gesellschaftlich
gesellschaftspolitisch
Gesellschaftsschicht
Gesetz
Gesicht
gespannt
Gespräch
Gespür
Gestalt
gestalten
Gestaltung
gestehen
gestern
gesund
Gesundheit
Gesundheitsversorgung
Gesundheitszeugnis
Getränk
Getreide
gewähren
gewährleisten
Gewährleistung
Gewalt
gewaltig
gewalttätig
Gewinn
gewinnen
Gewinnspanne
gewiss
Gewissen
gewissermaßen
Gewitter
Gewohnheit
gewöhnen
gewöhnlich
Gewürz
gießen
Gift
giftig
Gitarre
glänzen
Glas
glatt
Glaube
glauben
glaubhaft
glaubwürdig
Glaubwürdigkeit
Gleichberechtigung
gleichen
gleichfalls
Gleichheit
gleichzeitig
Gleis
gleiten
global
globalisiert
Globalisierung
Glut
glutenfrei
Glück
glücklich
Glückwunsch
gnädig
Gold
Golf
gott
Grafik
Gras
Grenze
Grieß
Grippe
groß
Großmutter
Großvater
Größe
Grund
Grundlage
grundsätzlich
Gruppe
Gruß
gründen
Gründer
gründlich
Gründung
grüßen
gucken
Gurke
Gut
Gutachten
Gutschein
gültig
Gültigkeit
günstig
Gürtel
gütig
Haar
haben
Habitus
haften
Haftpflicht
Haftpflichtversicherung
Haftung
Hagel
Hahn
Hai
Halbpension
Halle
Hals
halten
Haltestelle
hämmern
Hand
Handball
Handel
handeln
Handgepäck
Händler
Handlung
Handlungsempfehlung
Handlungsoption
Handlungsweise
Handwerker
Handwerker/in
Handy
hängen
Harmonie
hart
Hass
hassen
hässlich
häufig
Häufigkeit
Haupt
Hauptgrund
hauptsächlich
Hauptstadt
Haus
Hausaufgabe
Haushalt
Haut
Hebamme
Hebe
Hecke
Heft
heftig
heilen
heilig
Heimat
heimlich
Heimweh
heiraten
heiß
heißen
heiter
Heizung
Held
helfen
hell
Hemd
Henne
Herangehensweise
herausfinden
herausfordern
Herausforderung
Herbst
Herbstwind
Herd
herkommen
Herkunft
Herkunftsland
Herleitung
Herr
Herrschaft
herstellen
Herstellung
herunterladen
hervorbringen
hervorheben
Hervorhebung
hervorrufen
Herz
herzlich
heterogen
Heterogenität
heute
heutzutage
hier
Hierarchie
Hilfe
hilflos
hilfreich
hilfsbereit
Himmel
Himmelsblau
hin
hindern
hinfügen
hingegen
hinsichtlich
hinterfragen
Hintergrund
Hintergründe
hinterhältig
hinterlassen
hinterlegen
Hinweis
hinweisen
historisch
Hitze
Hobby
hoch
Hochzeit
Hof
hoffen
Hoffnung
hoffnungslos
hoffnungsvoll
Holz
Holzbank
Honig
Horrorfilm
Hose
Hostel
Hotel
höflich
Höhe
Höhepunkt
hören
Hörer/in
Huhn
humanitär
Humor
humorvoll
Hund
Hunger
Hupe
husten
Hut
hübsch
Hügel
Hülsenfrucht
hüpfen
Hygiene
hygienisch
Hypothese
Idee
Identifikation
Identifizierung
Identität
Identitätsbildung
Illusion
Illustration
Image
Immigration
Implementierung
Implikation
Import
Impressum
Impuls
Industrie
Infektion
Inflation
Information
Informationsflut
Informationsgesellschaft
Informationsquelle
Informationsverarbeitung
Infrastruktur
Inhalt
Initiative
Injektion
Inklusion
Inlineskaten
Innenraum
Innovation
Innovationskraft
Inschrift
Insekt
Inserat
Inspektion
Installation
Instanz
Institution
Instrument
Integration
Intelligenz
Intensität
Interesse
Interessenvertretung
Internet
Interpretation
Interview
Investition
Ironie
Isolation
idealerweise
identifizieren
identisch
ideologisch
ignorieren
illegal
illgitt
im
imaginär
imitieren
immer
implementieren
implizieren
imponieren
importieren
in
indem
individuell
industriell
infolgedessen
informativ
informieren
infrage
initiieren
inklusive
innerhalb
innerlich
innovativ
insistieren
insofern
institutionell
integrieren
integriert
intelligent
intensiv
interaktiv
interdisziplinär
interessant
interkulturell
intern
international
interpretieren
intolerant
investieren
involvieren
inzwischen
irgendwann
irgendwelche
irgendwer
irgendwie
ironisch
irritieren
isolieren
isoliert
Jacke
Jagd
Jahr
jahrelang
Jahreszeit
Jahrhundert
Jahrzehnt
Jammer
jammern
jauchzen
je
jedoch
jetzt
Journalist
Jugend
Jugendherberge
Jugendliche
jung
Junge
Juristik
juristisch
Justiz
Juwelier
Kaffee
Kaffeefilter
Kaffeetasse
Kakao
Kalen
Kalender
Kalkulation
kalkulieren
kalt
Kamera
Kamerad
Kamm
Kampagne
Kampf
Kanal
Kandidat
Kandidat/in
Kapazität
Kapital
Kapitel
Kapsel
kaputt
Karriere
Karte
Kartoffel
Käse
Kaskoversicherung
Kasse
Kassenbon
Kassenzettel
Katalog
katastrophal
Katastrophe
Kategorie
kategorisieren
Kategorisierung
Katze
kauen
Kauf
Kaufbestätigung
kaufen
Käufer/in
Kaufhaus
Kaufvertrag
kaum
kehren
kennen
kennenlernen
Kenntnis
Kennzeichen
kennzeichnen
Kennzeichnung
Kernaussage
Kernfrage
Kernkompetenz
Kernthematik
Kilometer
Kind
Kindheit
Kino
kippen
klagen
Klangfarbe
Klangwelt
klappen
klar
klären
Klärung
klassisch
kleben
Kleid
Kleidung
klein
klettern
klicken
Klima
Klimapolitik
Klimawandel
klingeln
klingen
klopfen
klug
kneifen
knüpfen
Kochbuch
kochen
Koffer
Kofferraum
kohärent
Kohärenz
Kollege
Kollegin
kombinieren
komfortabel
komisch
kommen
Kommentator/in
kommentieren
Kommissar/in
Kommunikation
Kommunikationsfähigkeit
Kommunikationsstärke
kommunikativ
kommunizieren
Komödie
Kompensation
kompensieren
kompetent
Kompetenz
Kompetenzentwicklung
Kompetenzförderung
komplex
Komplexität
kompliziert
Konferenzraum
Konflikt
Konfliktfähigkeit
Konfliktlösung
Konfrontation
konfrontieren
konkret
konkretisieren
Konkretisierung
Konkurrenz
konkurrenzfähig
konsequent
Konsequenz
konservativ
Konservendose
konsistent
Konsistenz
konstatieren
konstruieren
Konstruktion
konstruktiv
Konsum
konsumieren
konsumorientiert
Kontakt
Kontaktdaten
kontaktieren
kontinuierlich
Kontinuität
Konto
kontrollieren
kontrovers
Kontroverse
konventionell
Konzentration
konzentrieren
Kooperation
kooperativ
kooperieren
Koordination
koordinieren
Koordinierung
Kopf
Kopie
Kopierer
korrekt
korrigieren
Kosmetik
Kosten
kostenlos
kotzen
König/in
können
krachen
kräftig
krank
Krankenhaus
Krankheit
kreativ
Kreativität
Kreuung
Krieg
Kriegsende
Krimi
kriminell
Krippe
Kritik
Kritiker/in
kritisch
kritisieren
krumm
kulinarisch
Kultur
kulturell
Kunde
Kundenbefragung
kundenfreundlich
kundenorientiert
Kundenzufriedenheit
Kunststoff
kurz
Kuss
Küche
kühl
kümmern
kündigen
Kündigung
künstlich
kürzen
küssen
lächeln
lachen
Laden
Lage
Lager
Lagerfeuer
lahmen
laktosefrei
Lampe
Land
landen
lang
Langeweile
langfristig
langsam
langweilen
langweilig
Lärm
lassen
laufen
Laune
lauschen
laut
leben
lebendig
Lebenserfahrung
Lebenserwartung
Lebenslauf
Lebensqualität
lebhaft
leer
legen
legitim
Legitimation
Lehrer
Lehrerin
leicht
leiden
leidenschaftlich
leider
leihen
Leine
leise
leisten
Leistung
Leistungsbereitschaft
leistungsfähig
Leistungsfähigkeit
leistungsgerecht
leiten
Leiter
Leitlinie
Leitung
lenken
Lenkung
lernen
Lernfähigkeit
Lernstrategie
Leselampe
lesen
letzt
letztendlich
leuchten
Leuchtfeuer
Leuchtturm
Leute
liberal
Licht
Lichterkette
lieb
Liebe
Lieblingsbeschäftigung
Lied
Lieferbedingung
Lieferkette
liefern
Lieferung
liegen
lila
links
Liquidität
Literatur
Lob
loben
Loch
Locke
locken
Logik
logisch
Lohn
lohnen
lokal
Loyalität
löschen
lösen
Lösung
lösungsorientiert
Lösungsstrategie
Luft
lukrativ
Lunge
Lust
Luxus
lüften
Lüge
lügen
machen
Mädchen
Magazin
Magen
mahnen
malen
man
Manager/in
manchmal
mangeln
manipulieren
Mann
Mannschaft
Markt
Marktanalyse
Marktanteil
marschieren
Maschinenbau
Massentierhaltung
maßgebend
maßgeblich
massiv
Maßnahme
Matratze
Mauer
Mauerbau
Mauerfall
maximieren
Maximierung
meckern
Medienkompetenz
Medikament
Medizin
Meer
Meerblick
Meeresrauschen
Meerschweinchen
mehr
Mehrheit
mehrheitlich
mehrmals
Mehrsprachigkeit
meiden
meinen
meiner
Meinung
Meinungsbildung
Meinungsfreiheit
meistern
melden
Meldung
Menge
Mensch
Menschheit
menschlich
Mentalität
merken
Messe
messen
Metall
Methode
Methodik
methodisch
Miete
mieten
Mieterhöhung
Mietspiegel
Mietvertrag
Migration
Milchkarton
Milchzucker
Million
Millionär/in
Minderheit
mindern
Minderung
mindestens
minimieren
Minimierung
Minute
mischen
missachten
Missachtung
misslingen
misstrauen
Missverständnis
missverstehen
Mitarbeit
Mitarbeiter
mitbringen
mitdenken
miteinander
miterleben
Mitglied
mitmachen
mitreden
Mittag
Mittagessen
mitteilen
Mitteilung
Mittel
Mittelfeld
mittelständisch
mitten
Mitverantwortung
mitwirken
mobilisieren
Mobilisierung
Mobilität
Mode
Modell
modellieren
Moderation
Moderne
modernisieren
Modernisierung
Modifikation
Moment
Monat
Mondlicht
moralisch
Mord
Morgen
Morgenrot
Motivation
motivieren
motiviert
Motor
Motorhaube
Motorradfahrer/in
mögen
möglich
Möglichkeit
multiplizieren
Mund
murmeln
Museum
Musik
musikalisch
Mutter
Muttersprache
müde
Müll
Mülltonne
Mülltrennung
müssen
nachahmen
Nachahmung
Nachbar
Nachbarin
nachdenken
nachdenklich
Nachfrage
nachgeben
nachgehen
nachhaltig
Nachhaltigkeit
Nachhaltigkeitsstrategie
Nachhaltigkeitsziele
Nachkriegszeit
nachlassen
Nachmittag
Nachnahme
Nachricht
nachschlagen
nachsehen
Nacht
Nachteil
nachvollziehbar
Nachvollziehbarkeit
nachvollziehen
Nachweis
nachweisen
Nachweispflicht
Nachwuchsförderung
Nähe
nähern
Nährstoff
Nahrungsmittel
Name
naschen
nass
Nation
Nationalsozialismus
Natur
Naturkatastrophe
Naturprodukt
natürlich
Nebel
neben
nebenbei
neblig
nehmen
Nein
nennen
nett
neu
neugierig
Neuheit
neutral
neutralisieren
Neutralisierung
Neuwagen
nicht
nicken
nie
Niederlage
Niederlassung
niedrig
Niveau
noch
Nordstern
Norm
normal
normalisieren
normativ
Normierung
Not
Note
Notiz
Notizbuch
Notunterkunft
notwendig
Notwendigkeit
nötig
nstag
Nummernschild
nun
nur
Nuss
nutzen
Nutzung
nützen
nützlich
ob
oberflächlich
Objekt
objektiv
objektivieren
Objektivierung
Objektivität
Obst
Obstschale
obwohl
oder
offen
offenbar
offensichtlich
oft
ohne
Oldtimer
Onlineeinkauf
Onlineshop
Onlineshopping
Operation
operieren
Opfer
opfern
optimieren
Optimierung
optimistisch
Option
Orchester
ordentlich
ordnen
Ordnung
Organisation
Organisationseinheit
organisieren
orientieren
Orientierung
Orientierungslosigkeit
Original
originell
Ort
Ozean
öffentlich
Öffentlichkeit
öffnen
Öffnung
Ökologie
ökologisch
Ökonomie
ökonomisch
pachten
packen
Paket
Paketbote
Paketdienst
Papier
Papiermüll
Pappe
Paradies
Paradigma
paradox
parallel
Park
parken
Parklücke
Parkplatz
Partei
Partner
Partnerin
Party
Pass
Passagier/in
passen
Passform
passieren
Passkontrolle
Patient
pauschal
Pause
PC
Pension
Person
Personalabteilung
Personalwesen
Personenschaden
persönlich
Persönlichkeit
Persönlichkeitsentwicklung
Perspektive
Perspektivlosigkeit
pfeifen
Pflege
Pflegehelfer/in
Pflegekraft
pflegen
Pflicht
Phänomen
phänomenal
Phase
Philosophie
philosophieren
Physik
Picknick
Pille
Pilotenstreik
Pilz
plädiieren
Plan
planen
Planet
Planung
Plastik
Platz
platzen
plaudern
plausibel
Plausibilität
Plenum
Politik
politisch
Polizei
Pool
Porto
Portokosten
Position
positionieren
Positionierung
positiv
Post
Posteingang
prägen
Prägung
prahlen
Praktikum
praktisch
praktizieren
Präsentation
präsentieren
Präsenz
Prävention
präventiv
Praxis
praxisnah
praxisorientiert
präzise
Präzision
Preis
Presse
Prinzip
priorisieren
Priorisierung
Priorität
Privatnummer
Privileg
Probezeit
probieren
Problem
Problematik
problematisch
Problembewältigung
problemlos
Problemlösung
Problemlösungskompetenz
problemorientiert
Problemstellung
Produkt
Produktion
produktiv
Produktivität
produzieren
professionell
Professor
Profil
Profit
profitieren
Prognose
prognostizieren
Programm
Projekt
Projektleitung
Projektplanung
proklamieren
proportional
Proportionalität
Protest
protestieren
Prozessoptimierung
prozessorientiert
prüfen
Prüfung
PS
Publikation
Publikum
publizieren
Pullover
Punkt
putzen
pünktlich
quälen
Qualifikation
Qualifikationsanforderung
qualifizieren
qualifiziert
Qualifizierung
Qualität
qualitativ
Qualitätssteigerung
quantifizieren
Quantifizierung
Quantität
quantitativ
Quark
Quelle
quellen
quetschen
quietschen
Quittung
Quizshow
Quote
Rad
radeln
Radio
Radrennen
Rahmenbedingung
Rangliste
rasieren
raten
rational
rationalisieren
Rationalisierung
Rationalität
Ratschlag
Rätsel
rauchen
Raum
räumen
reagieren
Reaktion
realisierbar
realisieren
realistisch
Realität
rechnen
Rechnung
Recht
Rechte
rechtfertigen
Rechtfertigung
rechtlich
Rechtssystem
rechtzeitig
recyceln
Rede
reden
reduzieren
Reduzierung
Referat
referieren
reflektieren
reflektiert
Reflexion
Reflexionsfähigkeit
Reform
reformieren
Regel
regeln
Regelung
Regen
Regentropfen
regieren
Regierung
Region
regional
registrieren
Registrierung
regnen
regulär
regulieren
Regulierung
reich
reichen
Reichtum
Reifen
Reihe
reinigen
Reinigung
Reinigungsfirma
Reinigungsvertrag
Reise
Reisebüro
Reiselust
reisen
Reiseplan
Reiseplanung
Reisetagebuch
reiten
Reizüberflutung
Reklamation
Reklame
reklamieren
relevant
Relevanz
renovieren
rentabel
Rentabilität
Rente
rentieren
Rentner
Reparatur
Reportage
Reporter/in
Repräsentanz
Repräsentation
repräsentativ
Repräsentativität
repräsentieren
Republik
Reserve
reservieren
Resonanz
Respekt
respektieren
Ressource
ressourceneffizient
ressourcenintensiv
Ressourcenknappheit
ressourcenorientiert
Ressourcenplanung
ressourcenschonend
Restaurant
Restriktion
restriktiv
restrukturieren
Restrukturierung
Resultat
resultieren
Retoure
Retourenschein
retten
Rettung
revidieren
Revision
Revolution
revolutionär
revolutionieren
Rezept
richten
Richter
Richter/in
richtig
Richtung
riechen
risikieren
Risiko
Risikobereitschaft
Risikobewertung
riskieren
robust
Rolle
rollen
Roman
romantisch
Routine
routinemäßig
rufen
ruhen
Ruhezeit
ruhig
Ruine
Runde
rutschen
Rückblick
Rückerstattung
Rückgang
rückgängig
Rückkehr
Rücklicht
rückmelden
Rückmeldung
Rückscheibe
Rücksendung
Rücksicht
rücksichtsvoll
rückwärts
rühren
Sabotage
Sache
sachgerecht
sachlich
Sack
Saft
Sage
sagen
SalesManager/in
Salz
sammeln
Sammelstelle
Sammlung
Sandburg
sanieren
Sanierung
Satz
sauber
Sauberkeit
Schaden
Schadensfall
schädigen
schädlich
Schadstoff
schaffen
schalten
Schalter
schämen
schätzen
Schätzung
schauen
Schaufenster
Schauspieler
Scheck
Scheibe
scheiden
Scheidung
Schein
scheinen
Scheinwerfer
scheitern
schenken
scherzen
Schicht
schicken
Schicksal
schieben
Schiedsrichter
schießen
Schiff
Schild
schimpfen
schlafen
Schlafzimmer
schlagen
Schlange
schlecht
schließen
schließlich
schlimm
Schluss
schlussfolgern
Schlussfolgerung
Schlüssel
schmecken
schmeißen
schmelzen
Schmerz
Schmutz
schmutzig
schmücken
Schnee
Schneesturm
Schnei
schneiden
schneien
schnell
Schnitt
Schokolade
schon
schonen
schön
Schrank
schreiben
Schreibfeder
schreien
schreiten
Schrift
Schritt
schrittweise
Schuhe
Schuld
Schule
schulen
Schulung
Schutz
Schüler
Schülerin
schützen
Schwamm
Schwangerschaft
schwanken
Schwankung
Schwanz
schweigen
Schwein
schwellen
schwer
schwerwiegend
Schwester
schwierig
Schwierigkeit
Schwimmbad
schwimmen
schwinden
schwingen
schwitzen
schwören
See
Seeblick
Seele
Seestern
Segen
sehen
sehnen
Sehnsucht
sehr
Seifenoper
sein
seit
seitdem
Seite
Sekunde
selbstkritisch
Selbstorganisation
Selbstreflexion
selbstständig
Selbstständige
Selbstständigkeit
Selbstverantwortung
selbstverständlich
Selbstverwirklichung
Selektion
selektiv
selten
senden
Sendung
Seniorenheim
senken
sensibilisieren
Sensibilisierung
Serie
Service
Sessel
setzen
Shopping
sich
Sicherheit
sichern
siegen
Sieger/in
Signal
signifikant
Signifikanz
Silbermond
Simulation
simulieren
singen
sinken
Sinn
sinnen
Sinnhaftigkeit
sinnlos
sinnvoll
Sitte
Situation
sitzen
Skisport
so
Soap
sobald
sodass
Sofa
sofern
sofort
sogar
Solarenergie
sollen
somit
Sommer
Sommerregen
Sondermüll
Sonne
Sonnenschein
Sonnenschirm
Sonnenstrahl
Sonnenterrasse
Sonnenuntergang
Sorge
sorgen
sortieren
sowohl
sozial
Sozialkompetenz
Sozialpolitik
sozialverträglich
spalten
spannend
sparen
sparsam
später
spazieren
speichern
Speise
spekulieren
spenden
sperren
spezialisieren
Spezialisierung
Spezifikation
spezifisch
spiegeln
Spiel
spielen
Spielfilm
spionieren
SportUtilityVehicle
Sportwagen
Sprachbeherrschung
Sprache
Sprachkompetenz
Sprachnachweis
sprechen
springen
spüren
Staat
Staatsgründung
stabil
Stabilität
Stadion
Stadt
Stadtlicht
Standard
standardisieren
Standardisierung
standortabhängig
Standortsicherung
Standortwahl
Standpunkt
stark
Statistik
statistisch
staunen
stechen
stecken
stehen
stehlen
steigen
steigern
Steigerung
stellen
Stellenanzeige
sterben
Stern
Steuer
Steuerberater
Steuerberatungsbüro
steuern
Steuerung
Stichprobe
Stift
stiften
Stimme
stimmen
stinken
stinksauer
stoppen
stoßen
Stoßstange
stören
strafen
Straße
Straßenrand
Strategie
strategisch
streben
strecken
Streichholz
streiken
streiten
Stressbewältigung
Strom
Stromanbieter
Stromkosten
Struktur
strukturell
strukturieren
Strukturwandel
Student
Studie
studieren
Studium
Stuhl
Stunde
Sturm
stürzen
subjektiv
Subjektivität
Substanz
substanziell
subventionieren
suchen
suggerieren
Suggestion
summarisch
Supermarkt
süß
Systematik
systematisch
Tabelle
Tablette
tadeln
Tafel
Tag
tagen
Tagesablauf
Taktik
Talblick
Talkshow
tanken
tanzen
tarnen
Taschenlampe
Taschenmesser
Tat
Tätigkeit
Tatsache
tatsächlich
täuschen
Team
Teamarbeit
Teamfähigkeit
Teamkompetenz
Teamorientierung
Technik
technologiegestützt
Technologisierung
Tee
Teekanne
teilen
Teilhabe
Teilkaskoversicherung
Teilnahme
teilnehmen
Teilung
Telefon
telefonieren
Telekommunikation
Tendenz
tendieren
Teppich
Termin
termingerecht
Terminkalender
Terrorismus
testen
teuer
Text
Theater
Thema
thematisieren
Theorie
Ticket
Tiefkühlpizza
Tier
tierisch
Tierschutz
Tisch
Toilette
Toleranz
tolerieren
toll
Tomate
Ton
Tor
Torwart/in
total
Tote
Tour
töten
Tradition
traditionsreich
tragen
Trainer
trainieren
Training
Transferleistung
transparent
Transparenz
Transport
trauen
trauern
Traum
träumen
traumhaft
Traumreise
traurig
treffen
treiben
Treibstoff
Trend
trennen
Trennung
Treppe
treten
treu
trinken
Trinkwasser
trocken
tropfen
trotz
trotzdem
trotzen
trüb
Tsunami
tun
Turm
Tür
Tüte
Uferweg
Uhr
Uhrzeit
um
umdrehen
umfallen
umfangreich
umformulieren
Umfrage
Umgang
Umgebung
umgehen
Umleitung
Umsatz
umsetzbar
Umsetzbarkeit
umsetzen
Umsetzung
Umstand
umtauschen
Umwelt
Umweltbelastung
umweltfreundlich
Umweltschutz
Umweltverschmutzung
umziehen
Umzug
unabdingbar
unabhängig
Unabhängigkeit
unangenehm
unbedingt
unbekannt
und
Unfall
unfreundlich
ungeduldig
ungerecht
unglaublich
Universität
unmöglich
Unordnung
Unruhe
unten
unter
unterbrechen
unterfordern
unterhalten
Unterkunft
Unternehmen
Unternehmensführung
Unternehmenskultur
Unterricht
unterscheiden
Unterschied
unterschiedlich
unterschreiben
unterstreichen
unterstützen
Unterstützung
untersuchen
Untersuchung
unvermeidlich
unwichtig
Unzufriedenheit
unzureichend
urban
Urbanisierung
Urlaub
Urlauber/in
Ursache
ursachenorientiert
ursächlich
ursprünglich
Urteil
urteilen
Urteilsfähigkeit
über
übereinstimmen
Überfall
überfordern
Überforderung
übergeben
überlegen
Überleitung
übernachten
Übernachtung
ÜbernachtungmitFrühstück
überqueren
überraschen
Überraschung
überreden
Überschrift
Überschwemmung
übersetzen
Übersetzung
Übersetzungsbüro
übersichtlich
Überstunde
Übertragung
überweisen
Überweisung
überwinden
überzeugen
überzeugend
Überzeugung
Überzeugungskraft
üblich
übrigens
Übung
valide
Validität
Vater
verabreden
Verabredung
verabschieden
verallgemeinern
Verallgemeinerung
verändern
Veränderung
veranlassen
veranschaulichen
Veranschaulichung
Veranstaltung
verantwortlich
Verantwortung
verantwortungsbewusst
verantwortungsvoll
verarbeiten
Verarbeitung
verbessern
Verbesserung
verbieten
verbinden
verbindlich
Verbindlichkeit
Verbindung
Verbot
Verbrauch
verbrauchen
Verbraucher
Verbrechen
verbreiten
Verbreitung
verbringen
Verdacht
verdichten
Verdichtung
verdienen
Verdienst
vereinbaren
Vereinbarkeit
Vereinfachung
verfügbar
Verfügbarkeit
verfügen
Vergangenheit
Vergangenheitsform
vergessen
Vergleich
vergleichbar
Vergleichbarkeit
vergleichen
Vergnügen
vergrößern
Vergrößerung
Verhalten
Verhaltensweise
Verhältnis
verhandeln
Verhandlung
verheimlichen
verhindern
Verhinderung
Verifikation
verifizieren
Verkauf
Verkäufer
Verkehr
Verkehrsmittel
verknüpfen
Verknüpfung
Verlag
verlangen
verlängern
verlassen
Verlässlichkeit
verlegen
verlieren
Verlust
vermeiden
vermieten
Vermieter/in
Vermittelbarkeit
vermitteln
Vermittlung
vermuten
vermutlich
Vermutung
vernachlässigen
vernetzt
Vernetzung
Vernunft
vernünftig
veröffentlichen
Veröffentlichung
verpacken
Verpackung
verpassen
verpflichten
Verpflichtung
verraten
verreisen
Versammlung
versäumen
verschärfen
Verschärfung
verschieben
Verschiebung
verschlechtern
Verschlechterung
verschwenden
Verschwendung
verschwinden
versichern
Versicherung
verspäten
Versprechen
Verstand
Verständnis
verstärken
Verstärkung
verstehen
Versuch
verteilen
Vertrag
Vertrauen
vertreten
Vertreter
Vertretung
verursachen
Verwaltung
Verwandte
verwechseln
verweigern
Verwirrung
verzeihen
Verzicht
verzichten
verzögern
Verzögerung
viel
Vielfalt
vielfältig
vielleicht
vielseitig
Viertel
virtuell
Vogel
voll
von
vor
Vorausplanung
voraussetzen
Voraussetzung
voraussichtlich
vorbereiten
vorbeugen
Vorbildfunktion
vorgaukeln
vorhaben
Vorhersage
vorhersagen
vorkommen
vorläufig
Vorlesung
Vorschlag
vorschlagen
Vorsicht
vorsichtig
vorstellen
Vorstellung
Vorstellungsgespräch
Vorteil
vorteilhaft
Vortrag
Vorurteile
vorurteilsfrei
vorwerfen
vorwiegend
vorziehen
wachsen
Wachstum
Waffe
Wahl
wählen
während
währenddessen
Wahrheit
wahrnehmen
Wahrnehmung
Wahrnehmungsfähigkeit
wahrscheinlich
Wahrscheinlichkeit
Währung
Wald
Waldhütte
Wand
Wandel
Ware
warm
Wärme
warnen
Warnung
warten
Warteschlange
warum
waschen
Wasser
Wasserperle
Wechsel
wechseln
Wechselwirkung
wecken
Weg
Wegweiser
wegwerfen
Weide
weigern
weil
Wein
weinen
weisen
Weisheit
Weite
Weiterbildung
Weiterbildungsmöglichkeit
weiterentwickeln
weiterhin
Welle
Wellenreiter
Welt
weltweit
wenden
werben
Werbung
werden
werfen
Werkstatt
Wert
wertschätzen
Wertschätzung
wertvoll
wesentlich
Wettbewerb
wettbewerbsfähig
Wettbewerbsfähigkeit
wettbewerbsorientiert
Wetter
wichtig
widerspiegeln
widersprechen
Widerspruch
widmen
wie
wieder
wiederholen
wiegen
wild
Windrad
Winter
Wintersonne
wirken
wirklich
wirksam
Wirkung
Wirtschaft
wirtschaftlich
Wissen
Wissensaneignung
Wissenschaft
wissenschaftlich
Wissensgesellschaft
Wissenslücke
Wissensvermittlung
Witwe
wo
Woche
Wochenende
Wohnfläche
Wohnsitz
Wohnung
Wohnungssuche
Wolke
Wolkentor
Wolle
wollen
Wort
Wun
Wunde
wundern
Wunsch
Wunschtraum
Wut
wünschen
Zahl
zahlen
zählen
Zahlung
Zeichen
zeichnen
Zeichnung
zeigen
Zeit
Zeitplan
Zeitreise
Zeitschrift
Zeitung
Zelle
Zelt
Zement
Zentrum
zerstören
Zerstörung
Zertifikat
Zeuge
Ziegel
ziehen
Ziel
zielen
Zielerreichung
zielgerichtet
Zielgruppe
zielorientiert
Zielsetzung
zielstrebig
Ziffer
Zimmer
zitieren
Zivilisation
Zoll
Zone
zögern
zu
Zucker
zudem
zuerst
Zuflucht
zufrieden
Zufriedenheit
Zug
Zugang
zugänglich
Zugänglichkeit
Zugehörigkeit
zugleich
zugrunde
zuhören
Zuhörer
Zukunft
zukunftsfähig
Zukunftsfähigkeit
Zukunftsgestaltung
zukunftsorientiert
Zukunftsperspektive
zukunftsweisend
zukünftig
zulassen
Zulassung
Zulauf
zum
zumuten
Zumutung
Zunahme
zunehmen
zunehmend
Zuordnung
zur
zurechtkommen
zurückführen
Zusage
zusammen
Zusammenarbeit
zusammenarbeiten
zusammenfassen
zusammenfassend
Zusammenfassung
Zusammenhang
zusammenhängen
zusätzlich
zuschauen
zuschreiben
Zuschreibung
zusichern
Zustand
zuständig
Zuständigkeit
zustimmen
Zustimmung
Zustimmungsrate
zuverlässig
Zuverlässigkeit
Zuversicht
zuversichtlich
Zwang
zwangsläufig
zwar
Zweck
zweckmäßig
zweckorientiert
Zweifel
zweifellos
zweifeln
zweifelsfrei
Zwiebel
zwingen
abhalten von
abhängig von
Abhängigkeit von
achten auf
ankommen auf
anspruchsvolles Niveau
anstatt ... zu
antworten auf
ärgern über
auseinandersetzen mit
auskommen mit
ausrichten auf
aussagekräftige Daten
auswirken auf
bedanken bei
beitragen zu
bekannt geben
beklagen über
bemühen um
berichten über
berufen auf
beschäftigen mit
bescheid wissen
beschweren über
bestehen auf
bestehen aus
beteiligen an
bewerben um
beziehen auf
bitten um
bürgen für
charakteristisch für
danken für
darüber hinaus
effizient gestalten
effizient nutzen
eignen für
einerseits ... andererseits
einigen auf
einsetzen für
ekeln vor
empirische Studie
engagieren für
erinnern an
erkundigen nach
ernst nehmen
fähig sein
ganzheitlicher Ansatz
gehören zu
geltend machen
geraten in
gerecht werden
gesellschaftlich relevant
gesellschaftlicher Wandel
gewöhnen an
haften für
hinweisen auf
hoffen auf
im Gegenteil
in Anspruch nehmen
informieren über
infrage kommen
interdisziplinäre Zusammenarbeit
investieren in
jammern über
je ... desto
klagen über
konstruktiv kritisieren
konstruktiver Vorschlag
konzentrieren auf
lachen über
lebenslanges Lernen
leiden an
lohnen sich
mangeln an
meiner Ansicht nach
methodisches Vorgehen
nachhaltig wirtschaften
nachhaltige Entwicklung
nachvollziehbar sein
nähern sich
nicht nur ... sondern auch
objektive Bewertung
ohne ... zu
orientieren an
passen zu
plädiieren für
produktiv einsetzen
profitieren von
protestieren gegen
reagieren auf
rechnen mit
reflektiertes Denken
rentieren sich
resultieren aus
riechen nach
rückgängig machen
schämen für
scheitern an
schimpfen über
schützen vor
sehnen nach
sich eignen
sinnvoll einsetzen
sorgen für
sowohl ... als auch
sozial benachteiligt
soziale Integration
statistisch signifikant
staunen über
strategisches Denken
streben nach
streiten mit
teilnehmen an
telefonieren mit
tendieren zu
trauern um
träumen von
trennen von
um ... zu
umgehen mit
unterhalten sich
urteilen über
überzeugen von
verabreden sich
verantwortliches Handeln
verfügen über
vernetzt denken
verzichten auf
warnen vor
warten auf
weder ... noch
weigern sich
wenden an
werben für
wirtschaftliches Wachstum
wissenschaftlich belegen
wissenschaftlich fundiert
wissenschaftliches Arbeiten
wundern sich über
zielen auf
zielgerichtet handeln
zugrunde liegen
zukunftsorientiertes Handeln
zurechtkommen mit
zurückführen auf
zwar ... aber
zweifeln an`;

// ---------- Heuristic type detection ---------------------------------------
function detectType(word) {
  const w = word.trim();
  if (!w) return 'adverb';
  const hasUpper = /^[A-ZÄÖÜ]/.test(w);
  if (hasUpper) return 'noun';
  // Lowercase: try verb infinitive endings
  if (/[a-zäöüß]eren$/.test(w) || /[a-zäöüß]ieren$/.test(w)) return 'verb';
  if (/[bcdfghklmnpqrstvwxyz]en$/.test(w)) return 'verb';
  if (/(lich|ig|isch|bar|los|voll|haft|sam|reich|frei|fest|arm|tig|ent|haft|haftig)$/.test(w)) return 'adjective';
  // catch some common adjectives
  if (['gut','schön','schlecht','klein','groß','alt','neu','jung','breit','weit','tief','flach','klar','rein','wild','still','kühl','warm','heiß','kalt','hart','weich','klug','dumm','rund','dünn','dick','schnell','langsam','arm','reich','leicht','schwer','laut','leise','süß','sauer','bitter','salzig','frisch','müde','satt','hungrig','durstig','krank','gesund'].includes(w))
    return 'adjective';
  return 'adverb';
}

const seen = new Set();
export const SEED_WORDS = RAW.split('\n')
  .map((s) => s.trim())
  .filter((s) => s.length > 0)
  .filter((s) => {
    const k = s.toLowerCase();
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  })
  .map((german) => ({ german, type: detectType(german) }));

export const SEED_VERSION = 1;
